<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-19 16:18:36
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2020-07-02 11:12:33
--> 
<template>
  <pi-card :title="title"
           type="white">
    <span slot="header-right"
          @click="gotoTargetRoute(0)">查看所有订单</span>
    <div class="box-title"
         v-if="boxTitle !=''">{{boxTitle}}</div>
    <div class="pi-order-box">
      <div class="order-tab">
        <div class="tab-icon"
             @click="gotoTargetRoute(1)">
          <div class="order-num"
               v-if="data && data.unpaid">{{data.unpaid}}</div>
          <img src="../../../assets/image/order-icon-1.png">
        </div>
        <div class="tab-text">未支付</div>
      </div>
      <div class="order-flex"
           @click="gotoTargetRoute(2)">
        <div class="tab-icon">
          <!-- <div class="order-num"
               v-if="data && data.paid">{{data.paid}}</div> -->
          <img src="../../../assets/image/order-icon-2.png">
        </div>
        <div class="tab-text">已支付</div>
      </div>
      <div class="order-tab"
           @click="gotoTargetRoute(3)">
        <div class="tab-icon">
          <div class="order-num"
               v-if="data && data.abnormal">{{data.abnormal}}</div>
          <img src="../../../assets/image/order-icon-3.png">
        </div>
        <div class="tab-text">异常</div>
      </div>
    </div>
  </pi-card>
</template>
<script>
import Card from "@/components/pi-card/pi-card";
export default {
  name: "pi-order-tab",
  components: {
    [Card.name]: Card
  },
  data() {
    return {};
  },
  methods: {
    gotoTargetRoute(value) {
      //调整到订单列表页面
      let that = this;
      let query = {};
      if (this.userType == 4 || this.userType == 5) {
        query = {
          entUserPkId: that.accountPkId,
          orderState: value,
          isEntPayOrder: this.userType == 4 ? true : false
          // userType: this.userType
        };
      } else {
        query = {
          accountPkId: that.accountPkId,
          orderState: value,
          userType: this.userType == 1 ? "" : this.userType
        };
      }
      this.$router.push({
        name: "my/order",
        query: query
      });
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    accountPkId: {
      type: String,
      default: ""
    },
    boxTitle: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 1 普通会员  2 企业会员  3 企业支付  4企业管理员的企业支付  5 企业管理员的个人支付
    userType: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="less">
@import "../style/my-tab.less";
.box-title {
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #333;
  margin-top: 0.1rem;
}
</style>